import { Component, EventEmitter, Input, Output, inject, DestroyRef, ViewChild, effect } from '@angular/core';
import { AccountsService } from 'src/app/shared/services/accounts/accounts.service';
import { ResponseAnalyticsService } from 'src/app/shared/services/response-analytics/response-analytics.service';
import { ActionService } from 'src/app/shared/services/action/action.service';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { environment } from 'src/environments/environment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { forkJoin} from 'rxjs';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import * as _ from 'lodash'
import { ScoreDropdownMenuComponent } from '../../../../../../shared/components/score/score-dropdown-menu/score-dropdown-menu.component';
import { ScoreWidgetComponent } from '../../../../../../shared/components/score/score-widget/score-widget.component';
import { NgIf } from '@angular/common';
import { ScoreTableComponent } from '../../../../../../shared/components/score/score-table/score-table.component';
import { LtmsErrorComponent } from '../../../../../../shared/components/ltms-error/ltms-error.component';
import { LtmsLoaderComponent } from '../../../../../../shared/components/ltms-loader/ltms-loader.component';


@Component({
    selector: 'app-action-tat-hierarchy',
    templateUrl: './action-tat-hierarchy.component.html',
    styleUrls: ['./action-tat-hierarchy.component.scss'],
    imports: [ScoreDropdownMenuComponent, ScoreWidgetComponent, NgIf, ScoreTableComponent, LtmsErrorComponent, LtmsLoaderComponent]
})


export class ActionTatHierarchyComponent {
  @Input() overallData: any = {}
  @Input() componentId: string = "ltms-hierarchy-" + this.getTimeStamp()
  @Output() onFiltersChange: any = new EventEmitter<any>()
  @Output() onDrilldownChange = new EventEmitter<any>();
  @ViewChild(ScoreWidgetComponent) scoreWidgetComponent!: ScoreWidgetComponent;
  destroyRef = inject(DestroyRef);
  title: string = 'Summary';
  discription: string = 'Detailed breakdown of closed issues by various dimensions, showing total, solved, average TAT, and counts within/missed target TAT.';
  containerId: string = "ltms-hierarchy-table-container"
  viewTypeDropdown: any = {config: {width: '128px', isDisabled: true, tab: 'actionTatTable'}, selectedOption: '', options: []};
  timestamp: number = new Date().getTime()
  childDataCount = 0;
  accountDetails: any = {}
  downloadQueryParams: any = {}
  downloadReportOverallHeader: any = [];
  downloadReportDrilldownHeader: any = [];
  childStaticId = "Child-Summary-" + this.timestamp
  overallStaticId = "Overall-Summary-" + this.timestamp
  fullScreenLeftBox: boolean = false;
  showPercentage: boolean = false;
  errorCode: string = '404';
  isDataAvailable: boolean = false;
  brandId: string = '';
  requestParameters: any = [];
  fromDate: string = '';
  toDate: string = '';
  hierarchyList: any = [];
  hierarchyListAliasValue: any = [];
  hierarchyMapping: any = {};
  newHierarchyStack: any = [];
  lastSelectedFields:any = {};
  universalFilter: any = {};
  currentHierarchyLevel: any = '';
  currentHierarchyLevelName: any = '';
  date_filter_type: number = 1;
  rater_type: number = 0;
  project_type: number = 0;
  dropdown: any = {
    groupBy: "category",
    isDefaultSelection: true,
    categorization: true,
    preffix: "By ",
    elementid: 'ltms-dropdown-' + this.timestamp,
    options: []
  }
  mappedQuestions: any = {}
  parent_herarchy: any[] = []
  childData = {
    elementId: "child-summary-" + this.timestamp,
    config: {
      shorting_enabled: true,
    },
    data: [],
    columns: []
  }

  // initial config for new parant datatable 
  distributionTable: any = {
    tablePlugins: {
      isTableResize: true,
    },
    tableHeader: [],
    tableRow: [],
    tableFooter: []
  };
  // initial config for new child/drilldown datatable 
  comapreWithTable: any = {
    tableHeader: [],
    tableRow: [],
    tableFooter: []
  };

  drillDownList: any = []
  appliedDrilldownList: any = []
  dateFilterField = _.get(Helpers, 'datePicker.dateFilterType', 1) == 1 ? "feedback_request_date" : "created_date";
  selectedCustomFilter: any = {}

  filterObj: any = {
    currentFilter: {},
    nextFilter: {},
    appliedfilters: [],
    next: {}
  }

  brandDetail: any = {};
  hierarchyStack: any = [];
  apiParameters: any = [];
  addOnList: boolean = true;
  exportData: any = [];
  questionMapping: any = {};
  group_key_alias: string = '';
  startDate: any = '';
  endDate: any = '';

  overAllTableId: string = `${this.overallStaticId}-${this.getTimestamp()}`;
  childTableId: string = `${this.childStaticId}-${this.getTimestamp()}`;
  overallTable: any = {
    isChildTable: false,
    columns: [],
    rows: []
  }
  drilldownTable: any = {
    isChildTable: false,
    columns: [],
    rows: []
  }
  isDataLoaded: boolean = false;
  isHierarchyUpdated: boolean = false;
  // TODO: implement functionality to store hierarchy data
  selectedHerarchy: any = {};

  constructor(
    private accountsService: AccountsService,
    private _analytics: ResponseAnalyticsService,
    private actionService: ActionService,
    private _utilsService: UtilsService,
    private _helpers: HelpersService,
    private _toast: ToastService,
    private appStateService:AppStateService
  ) {
    effect(() => {
      if (this.appStateService.initialized()) {
        let params:any = this.appStateService.appState();
        if (params) {
          this.startDate = params.datePicker.startDate;
          this.endDate = params.datePicker.endDate;
          this.universalFilter = params.universalFilter ? params.universalFilter : {};
          this.accountDetails = params.accountDetails;
          // this.hierarchyStack = params.hierarchyStack;
          this.isHierarchyUpdated = false
          if (!_.isEqual(params.hierarchyStack, this.hierarchyStack)) {
            this.hierarchyStack = params.hierarchyStack
            this.isHierarchyUpdated = true;
          }
          let field_id: string = '';
          if (this.hierarchyStack && this.hierarchyStack.length) {
            field_id = this.hierarchyStack[this.hierarchyStack.length -1].field_id;
          }
          this.group_key_alias = this.actionService.getGroupAliasKey(field_id, params.brandDetails.hierarchy_list_alias)
          if (this.brandId != params.brandDetails._id) {
            this.brandId = params.brandDetails._id;
            this.brandDetail = params.brandDetails
            this.setBrandDetail(field_id)
          } else {
            let isExpanded = this.actionService.drilldownTable?.tableRow?.some(item => item.isExpanded);
            if(isExpanded && !this.isHierarchyUpdated){
              this.requestParameters = [];
              this.childDataCount = 0;
              this.comapreWithTable = Helpers.deepClone(this.actionService.drilldownTable);
              this.isDataLoaded = false;
              this.getSelectedDrilldownData()
              const selectedFilter = this.actionService.getSelectedDrilldownFilter()
              if(selectedFilter){
                this.updateFilters(selectedFilter);
              }
            }else{
              this.isDataLoaded = false;
              // this.hierarchyStack = this.newHierarchyStack
              // this.getChildData();
              this.setBrandDetail(field_id)
            }          
          }
        }
      }
    });
    // Add event listeners for Escape key and click outside
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
    document.addEventListener('click', this.handleClickOutside.bind(this));
  }

  scoreWidget(type: string): any {
    return {
      isFullScreenButtonShow: true,
      isDownloadButtonShow: true
    };
  }

  getTimeStamp() {
    return new Date().getTime();

  }
  ngOnInit(): void { }

  ngOnChanges() {
    this.initializeOverall();
  }


  getSelectedDrilldownData(){
    let reqParams = this.getRequestParameters()
    delete reqParams?.field_id;
    delete reqParams?.hierarchy_stack;
    const drilldown_hierarchy = this.actionService.generateApiParams(this.comapreWithTable?.tableRow, reqParams);
    let apiParams: any = drilldown_hierarchy.api_params;
    const filters = drilldown_hierarchy.filters;
    let response: any = {}
    let apiCalls: any = {}
    if(apiParams.length){
      let topLevelParams = Helpers.deepClone(apiParams[0])
      let topLevelParamFieldId = '';
      if (topLevelParams && topLevelParams.field_type == "hierarchy" && topLevelParams.filters && topLevelParams.filters.length) {
        topLevelParamFieldId = topLevelParams.filters[0].field_id
      } else if (this.selectedCustomFilter && this.selectedCustomFilter.field_id) {
        topLevelParamFieldId = this.selectedCustomFilter.field_id
      }
      topLevelParams.field_id = topLevelParamFieldId
      topLevelParams.group_key_alias = this.actionService.getGroupAlias(topLevelParamFieldId)
      delete topLevelParams?.hierarchy_stack;
      apiParams.push(topLevelParams)
      this.requestParameters = apiParams;
      _.forEach(apiParams, (params) => {
        delete params?.filters;
        if (params.field_type == 'tag') {
          params.hierarchy_stack = this.hierarchyStack
        }
        apiCalls[params.field_id] = this.actionService.getComparisonData(params);
      })
      forkJoin(apiCalls).subscribe(allResponses => {
        
        _.forEach(allResponses, (value, key) => {
          let dataMapper:any = {}
          const dataArray = this.processChildData(value, key)

          _.forEach(dataArray, (data) => {
            dataMapper[data.key] = data
          })
          response[key] = dataMapper
        })

        this.updateTableBySelectionHistory(response, Helpers.deepClone(this.comapreWithTable.tableRow))
      })
    }
  }

  updateTableBySelectionHistory(responseData: any[][],tableDataWithCache: any): void {
    this.comapreWithTable.tableRow = this.recursivelyUpdateDrilldown(responseData, tableDataWithCache, 0);
    this.isDataLoaded = true;
  }

  // Process each item in the cached data
  recursivelyUpdateDrilldown(responseData, tableDataWithCache, levelIndex) {
    if (!tableDataWithCache || !tableDataWithCache.length) {
      return tableDataWithCache;
    }

    let fieldId:any = tableDataWithCache[0].field_id;
    if (tableDataWithCache[0].field_type == "hierarchy" && levelIndex == 0) {
      this.comapreWithTable.tableHeader = this.getExportColumns(this.hierarchyMapping[fieldId]);
    }
    let cachedDataMap: any = {}
    let cachedKeys = _.map(tableDataWithCache, (data) => {
      cachedDataMap[data.key] = data
      return data.key
    })

    let newKeys = _.map(responseData[fieldId], (data) => {
      return data.key
    })

    let mergedKeys = [...cachedKeys, ...newKeys]

    mergedKeys = _.uniq(mergedKeys);

    let tableData:any = []

    _.forEach(mergedKeys, (key) => {
      const cachedItem:any = cachedDataMap[key]
      const newData:any = _.get(responseData, fieldId+"."+key);
      let mergedItem:any = {
        ...cachedItem,
        doc_count:  0,
        resolved: 0,
        unresolved: 0,
        within_tat: 0,
        outside_tat:  0,
        actionables:  0
      };

      if (!_.isEmpty(newData)) {
        mergedItem = {
          ...cachedItem, ...newData
        };

        if (cachedItem && cachedItem.field_child) {
          mergedItem.field_child = cachedItem.field_child 
        }

        if (!_.isEmpty(this.lastSelectedFields) && (this.lastSelectedFields.field_id == newData.field_id)) {
          mergedItem.field_child = this.lastSelectedFields.field_child

          if (this.lastSelectedFields.drillDown) {
            mergedItem.drillDown = []
          }
        }

        // Update percentages
        mergedItem.percent = {
          doc_count: this.getPercentage(mergedItem.doc_count, mergedItem.doc_count),
          resolved: this.getPercentage(mergedItem.resolved, mergedItem.doc_count),
          unresolved: this.getPercentage(mergedItem.unresolved, mergedItem.doc_count)
        };

        mergedItem.resolved_with_percentage = mergedItem.resolved + '(' + mergedItem.percent.resolved + '%)';
        mergedItem.unresolved_with_percentage = mergedItem.unresolved + '(' + mergedItem.percent.unresolved + '%)';

        // tableData.push(newData)
      }else {
        // If no new data found for this field_id, set all numeric values to 0
        mergedItem = {
          ...cachedItem,
          doc_count: 0,
          resolved: 0,
          unresolved: 0,
          within_tat: 0,
          outside_tat: 0,
          actionables: 0,
          percent: {
            doc_count: '0.0',
            resolved: '0.0',
            unresolved: '0.0'
          },
          resolved_with_percentage: '0(0.0%)',
          unresolved_with_percentage: '0(0.0%)'
        };
      }

      // Recursively process drilldown data if it exists
      if (cachedItem && cachedItem.drillDown && cachedItem.drillDown.length) {
        // mergedItem.isExpanded = true
        mergedItem.drillDown = this.recursivelyUpdateDrilldown(responseData, cachedItem.drillDown, levelIndex + 1);
      }

      if (cachedItem && cachedItem.field_id) {
        this.lastSelectedFields = {
          'field_id': cachedItem.field_id,
          'field_child': cachedItem.field_child
        }

        if (_.has(cachedItem, 'drillDown')) {
          this.lastSelectedFields['drillDown'] = true
        }
      }
      
      tableData.push(mergedItem)

    })

    // while the table retaining if the child table data more than 100 then the data will be download using JOB
    if (tableData && tableData.length >= 100) {
      this.childDataCount = tableData.length
      let params = _.find(this.requestParameters, { "field_id": fieldId });
      this._toast.showPopup('WARN', 'Warning', 'More than 100 results found in the table for the current selection of the filters, sort is unavailable. Please download the data to view the entire range.', 7000);
      const exportQuery = this.prepareDownloadQuery(params);
      this.downloadQueryParams = exportQuery;
    }

    return tableData

    
  }

  onFilterChange(data: any) {
    this.isDataLoaded = false;
    this.appliedDrilldownList = [];
    this.filterObj.appliedfilters = [];
    this.drillDownList = [];
    this.drilldownTable.rows = [];
    this.filterObj.nextFilter = data
    this.selectedCustomFilter = data
    this.viewTypeDropdown.selectedOption = data.name
    this.comapreWithTable.tableHeader = this.getExportColumns(this.selectedCustomFilter['name']);
    // this.widgetConfig.download.data.fileName = 'Action Summary - TAT_By_' + this.selectedCustomFilter.name;
    // this.widgetConfig.download.data.title = 'Action Summary - TAT - By ' + this.selectedCustomFilter.name;
    this.group_key_alias = this.actionService.getGroupAlias(data.field_id)
    this.onDrilldownChange.emit({
      filters: this.filterObj.appliedfilters
    })
    this.initializeOverall();

    this.getChildData()
  }

  onViewChange(viewType: any) {
    this.showPercentage = (viewType == 'percent') ? true : false
    this.updateColumns()
    this.overAllTableId = `${this.overallStaticId}-${this.getTimestamp()}`;
    this.childTableId = `${this.childStaticId}-${this.getTimestamp()}`;
  }

  updateColumns() {
    if (!_.isEmpty(this.overallTable.rows)) {
      const displayName = this.overallTable.columns[0].header;
      this.overallTable.columns = this.getExportColumns(displayName)
    }
    if (!_.isEmpty(this.drilldownTable.rows)) {
      const level_name = this.drilldownTable.columns[0].header;
      this.drilldownTable.columns = this.getExportColumns(level_name);
      this.drilldownTable.rows = this.mapColumns(this.drilldownTable.rows);
    }
  }

  mapColumns(list: any) {
    return _.map(list, (object: any) => {
      if (_.hasIn(object, 'child.rows') && !_.isEmpty(object.child.rows)) {
        const lavel_name = object.child.columns[0].header;
        object.child.columns = this.getExportColumns(lavel_name);
        object.child.rows = this.mapColumns(object.child.rows);
      }
      return object
    })
  }


  initializeOverall() {
    this.exportData = []
    this.prepareDownloadQuery(this.overallData.query)
    // TODO: passe selected hierarchy or brand name insteade of "Project"
    this.overallTable.columns = this.getExportColumns('Project');
    if (this.hierarchyStack && this.hierarchyStack.length) {
      // this.distributionTable.tableHeader = this.getExportColumns(this.hierarchyMapping[this.currentHierarchyLevel]);
      this.distributionTable.tableHeader = this.getExportColumns(this.hierarchyMapping[this.hierarchyStack[0].field_id]);
    } else {
      this.distributionTable.tableHeader = this.getExportColumns('Project');
    }
    // this.distributionTable.tableHeader = this.getExportColumns(this.hierarchyMapping[this.currentHierarchyLevel]);
    this.downloadReportOverallHeader = this.getExportColumnsForReport(this.hierarchyMapping[this.currentHierarchyLevel]);
    this.comapreWithTable.tableHeader = this.getExportColumns(this.selectedCustomFilter['name']);
    this.distributionTable.tableRow = this.overallData.data;
    // this.widgetConfig.download.data.fileName = 'Action Summary - TAT_By_' + this.selectedCustomFilter.name;
    // this.widgetConfig.download.data.title = 'Action Summary - TAT - By ' + this.selectedCustomFilter.name;
    this.overallTable.rows = this.overallData.data;
    this.overAllTableId = "overall-summary-" + this.getTimestamp();
    this.exportData.push({
      field_id: 'overall',
      order: this.exportData.length,
      columns: this.getExportColumnsForReport(this.hierarchyMapping[this.currentHierarchyLevel]),
      rows: this.overallData.data
    })
  }

  initDropdownOptions(options: any) {
    if (!_.isEmpty(options)) {
      // this.group_key_alias = 'brands'
      this.viewTypeDropdown.config.isDisabled = false;
      this.viewTypeDropdown.selectedOption = options[0].name
      this.viewTypeDropdown.options = options
      this.selectedCustomFilter = options[0]
      this.filterObj.nextFilter = this.selectedCustomFilter
      this.dropdown.options = options
      this.dropdown.elementid = 'ltms-dropdown-' + new Date().getTime()
      // this.widgetConfig.download.data.fileName = 'Action Summary - TAT_' + this.brandDetail.name + "_" + this.selectedCustomFilter.name;
      // this.widgetConfig.download.data.title = 'Action Summary - TAT';
    } else {
      this.viewTypeDropdown.config.isDisabled = true;      
    }
  }

  setBrandDetail(field_id:string): void {
    this.rater_type = _.get(this.brandDetail, 'main_rater_type');
    this.project_type = _.get(this.brandDetail, 'project_type');
    this.questionMapping = this.actionService.configureActionService(this.brandDetail)
    const dropdownDetails = this.actionService.prepareViewTypeDropdown(this.brandDetail, this.hierarchyStack);
    var options: any = dropdownDetails.options;
    this.hierarchyMapping = dropdownDetails.hierarchyMapping
    this.currentHierarchyLevel = dropdownDetails.currentHierarchyLevel 
    this.initDropdownOptions(options)
    this.drilldownTable.rows = []
    this.isDataLoaded = false;
    this.filterObj.appliedfilters = [];
    this.onDrilldownChange.emit({
        filters: this.filterObj.appliedfilters
    })
    this.getChildData()
  }

  getTimestamp() {
    return new Date().getTime();
  }

  getChildData(event?:any) {
    // this.isDataLoaded = false;
    let displayName: any = ''
    if (event && event.field_type == 'tag') {
      displayName = this.actionService.filterNameMap[this.filterObj.nextFilter.field_id].name
    } else {
      displayName = _.get(this.filterObj, 'nextFilter.name', 'Name')
    }
    // const displayName = _.get(this.filterObj, 'nextFilter.name', 'Name')
    const fieldId = _.get(this.filterObj, 'nextFilter.field', '')

    let params = this.getRequestParameters()
    params.group_key_alias = this.group_key_alias
    params.from = this.startDate
    params.to = this.endDate

    this.actionService.getComparisonData(params).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: (responseObject) => {
        if (this.validateApiResponse(responseObject)) {
          let rowData:any = [];
          const columns = this.getExportColumns(displayName)
          this.childData.elementId = "child-summary-" + this.getTimestamp();
          let rows = this.processChildData(responseObject)
          // rowData.push({
          //   name: columns[0].header,
          // })
          // const processedData = this.getMappedData(responseObject, columns)

          this.exportData.push({
            field_id: fieldId,
            order: this.exportData.length,
            columns: this.getExportColumnsForReport(displayName),
            rows: this.processChildData(responseObject)
          });

          // if (this.questionMapping.questions && this.questionMapping.questions.primary_rating) {
          //   this.widgetConfig.download.data.interaction = this.questionMapping.questions.primary_rating.text
          // }

          if (rows && rows.length) {
            _.each(rows, row=>{
              rowData.push(row)
            })
          }

          if (event && event.drillDown) {
            event.drillDown = rowData;
            event.columns = columns;
            event.header =  this.getExportColumnsForReport(displayName)
            this.actionService.getInitializedTable(this.comapreWithTable)
          }else {
            this.comapreWithTable.tableRow = rows
            this.downloadReportDrilldownHeader = this.getExportColumnsForReport(displayName)
          }

          if (rows && rows.length >= 100) {
            // sorting button is hiding incase of more than 100 rows
            this.comapreWithTable.tableHeader = _.map(this.comapreWithTable.tableHeader, column=>{
              column.isSorting = false;
              return column;
            })
            this._toast.showPopup('WARN', 'Warning', 'More than 100 results found in the table for the current selection of the filters, sort is unavailable. Please download the data to view the entire range.', 7000);
            // this.widgetConfig["downloadFromJob"] = true;
            const exportQuery = this.prepareDownloadQuery(params);
            this.downloadQueryParams = exportQuery;
            // this.widgetConfig.download.query = exportQuery;
          } else {
            // this.widgetConfig.download.data.hasMultipleReports = true;
            // this.widgetConfig.download.data.rows = this.exportData;
          }
          this.isDataLoaded = true;
          this.isDataAvailable = true;
        }
        else {
          this.isDataAvailable = false;
          this.isDataLoaded = true;
        }
      },
      error: (err) => {
        this.isDataAvailable = false;
        this.isDataLoaded = true;
        if (err.status == '500') {
          this.errorCode = '500'
        } else if (err.status == "404") {
          this.errorCode = '404'
        } else if (err.status == "408") {
          this.errorCode = '408'
        }
      }
    })
  }

  validateApiResponse(response: any) {
    return (response.code == 0 && _.hasIn(response, 'data.RatingsSummary') && !_.isEmpty(response.data.RatingsSummary) && _.hasIn(response, 'data.tat'))
  }

  onDrillDown(data?: any, eventType?: string) {
    if(data.isExpanded){
      this.actionService.getInitializedTable(this.comapreWithTable)
    }
    this.updateFilters(data, eventType)
  }

  updateFilters(data?: any, eventType?: string) {
    this.actionService.setDrilldownFilters(data);
    this.actionService.setSelectedDrilldownFilter(data)

    // this.exportData = this.exportData.splice(this.exportData.length - 1, 1);
    this.apiParameters = this.apiParameters.splice(this.apiParameters.length - 1, 1);
    // this.filterObj.appliedfilters = this.actionService.clone(data.filters);
    if (data.filters) {
      this.filterObj.appliedfilters = JSON.parse(JSON.stringify(data.filters));
    }
    // Set data as current filter that
    this.filterObj.currentFilter = this.actionService.clone(data);
    // TODO: update the download functionality
    if (this.addOnList) {
      this.exportData.push({
        field_id: data.field_id,
        order: this.exportData.length,
        columns: this.getExportColumnsForReport(data.field_name),
        rows: [data]
      })
    }


    if (data.field_type == 'hierarchy') {
      this.filterObj.nextFilter = this.actionService.getNextHierarchy(data.field_id)
      this.selectedCustomFilter = this.filterObj.nextFilter
    } else if (data.field_type == 'touchpoint') {
      this.filterObj.nextFilter = {};
    } else if (data.field_type == 'tag' || data.field_type == 'response') {
      if (data.field_child && !_.isEmpty(data.field_child)) {
        this.filterObj.nextFilter = JSON.parse(JSON.stringify(data.field_child));
        // If field type is response then set it as type and change type of question to sub_type
        if (data.field_type && data.field_type == 'response') {

          if (data.type == "multi-select") {
            this.filterObj.nextFilter = this.actionService.getPrpsAndPossibleValuesForMultiSelect(this.filterObj.nextFilter);
          }

          this.filterObj.nextFilter.field_sub_type = JSON.parse(JSON.stringify(this.filterObj.nextFilter.type));
          this.filterObj.nextFilter.type = 'response';
        } else {
          this.filterObj.nextFilter.type = 'tag';
        }
      } else {
        this.filterObj.nextFilter = {};
      }
    }

    var applyFilterObj = {
      field_id: data.field_id,
      field_type: data.field_type,
      field_sub_type: data.field_sub_type,
      field_value: data.name,
      group_key : [data.name],
      field_data_type: data.field_data_type
    }
    if (applyFilterObj.field_type == 'response') {
      if (!isNaN(applyFilterObj.field_value)) {
        applyFilterObj.field_value = parseInt(applyFilterObj.field_value);
      }
      if (applyFilterObj.field_sub_type == 'multi-select') {
        _.each(this.filterObj.currentFilter.field_possible_values, function (obj: any) {
          if (obj.value == applyFilterObj.field_value) {
            applyFilterObj.field_id = obj.field_id;
          }
        });
      }
    }

    const currentLevel = parseInt(applyFilterObj.field_id.split('_')[2]);
    
    this.filterObj.appliedfilters = this.filterObj.appliedfilters.filter(filter => {
      const filterLevel = parseInt(filter.field_id.split('_')[2]);
      return filterLevel < currentLevel;
    });
    
    this.filterObj.appliedfilters.push(applyFilterObj);

    if (data.field_id != 'touchpoint') {
      this.group_key_alias = data.field_id
      this.onDrilldownChange.emit({
        filters: this.filterObj.appliedfilters,
        groupKeyAlias: this.group_key_alias
      })
      // while collapse the drilldown row prevent to call child data api
      if ((!_.has(data, 'isExpanded') || data.isExpanded == false) && eventType == 'drilldown') {
        this.getChildData(data)
      }
    }

  }

  removeDrillDown(data: any) {
    if (data.field_id != 'touchpoint') {
      this.group_key_alias = data.field_id
      const index = _.findIndex(this.appliedDrilldownList, { field_id: data.field_id })
      this.appliedDrilldownList.splice(index + 1, this.appliedDrilldownList.length)
      this.filterObj.appliedfilters.splice(index + 1, this.filterObj.appliedfilters.length)

      const exportDataIndex = _.findIndex(this.exportData, { field_id: data.field_id })
      this.exportData.splice(exportDataIndex + 1, this.exportData.length)

      const exportQueryIndex = _.findIndex(this.apiParameters, { field_id: data.field_id })
      this.apiParameters.splice(exportQueryIndex + 1, this.apiParameters.length)

      this.filterObj.currentFilter = data
      if (data.field_type == "hierarchy") {
        this.filterObj.nextFilter = this.actionService.getNextHierarchy(data.field_id)
      } else {
        this.filterObj.nextFilter = this.selectedCustomFilter
      }
      this.onDrilldownChange.emit({
        filters: this.filterObj.appliedfilters,
        groupKeyAlias: this.group_key_alias
      })
      this.getChildData()
    }
  }

  resetHierarchData() {
    this.appliedDrilldownList = [];
    this.filterObj.appliedfilters = [];
    this.drillDownList = [];
    this.addOnList = true
    let selectedFilter = this.viewTypeDropdown?.options.find(item => item.name === this.viewTypeDropdown?.selectedOption)
    this.onFilterChange(selectedFilter)
    this.filterObj.nextFilter = this.selectedCustomFilter;
    this.group_key_alias = this.actionService.getGroupAlias(this.selectedCustomFilter.field_id)
    const exportDataIndex = _.findIndex(this.exportData, { field_id: 'overall' })
    this.exportData.splice(exportDataIndex + 1, this.exportData.length)

    const exportQueryIndex = _.findIndex(this.apiParameters, { field_id: 'overall' })
    this.apiParameters.splice(exportQueryIndex + 1, this.apiParameters.length)

    this.onDrilldownChange.emit({
      filters: this.filterObj.appliedfilters,
      groupKeyAlias: this.group_key_alias
    })

    this.getChildData()
  }

  getRequestParameters() {
    var params: any = {}
    var rateType = (Helpers.brandDetails && Helpers.brandDetails.main_rater_type) ? Helpers.brandDetails.main_rater_type : null;
    var sortBy = 'average_rating';
    if (rateType == 3 || rateType == 10) {
      sortBy = 'nps_score';
    }
    params = this.actionService.getInitialQueryParameters();
    if (Helpers.hierarchyStack && Helpers.hierarchyStack.length) {
      params.hierarchy_stack = Helpers.hierarchyStack;
    }
    if (_.hasIn(this.filterObj, 'appliedfilters') && this.filterObj.appliedfilters.length) {
      params.filters = this.filterObj.appliedfilters;
    }

    params.from = _.get(Helpers, "datePicker.startDate");
    params.to = _.get(Helpers, "datePicker.endDate");
    params.view_type = 'list';
    params.action_type = 'tat';
    params.brand_id = this.brandId;
    params.universal_filter = this.universalFilter;
    params.field_id = this.filterObj.nextFilter.field_id;
    params.field_type = this.selectedCustomFilter.field_type || "hierarchy";
    params.question_aggs = true;
    params.is_custom_date_range_selected = true;

    if (this.selectedCustomFilter.data_type && this.selectedCustomFilter.data_type == "range" && this.selectedCustomFilter.possible_values && this.selectedCustomFilter.possible_values.length) {
      params.field_data_type = this.selectedCustomFilter.data_type;
      params.possible_values = this.selectedCustomFilter.possible_values;
    }

    if (this.selectedCustomFilter.field_type && this.selectedCustomFilter.field_type == "response" && this.selectedCustomFilter.possible_values && this.selectedCustomFilter.possible_values.length) {
      params.field_type = "response";
      if (this.selectedCustomFilter.type == "multi-select") {
        // this.selectedCustomFilter = getPossibleValuesForMultiSelect(this.selectedCustomFilter);
      }
      params.possible_values = this.selectedCustomFilter.possible_values;
      params.field_sub_type = this.selectedCustomFilter.type;
    }

    // // If filter object is available then it will take data from that
    if (this.filterObj && this.filterObj.appliedfilters && this.filterObj.appliedfilters.length) {
      // Set filters object if it is available. 
      params.filters = this.filterObj.appliedfilters;
    }
    params.actionable_filter = _.get(this.brandDetail, "action_management_configuration.actionables", {});
    params.date_field = this.dateFilterField || 'created_date';
    params.age_type = _.get(this.brandDetail, "action_management_configuration.ageing_config.type", 1);
    params.turnaround = _.get(this.brandDetail, "action_management_configuration.ageing_config.turnaround_time", 0);
    return params
  }

  getMappedData(response: any, columns: any) {
    let list = _.get(this.drilldownTable, 'rows', []);
    const childData: any = this.processChildData(response);
    if (!_.isEmpty(list)) {
      this.drilldownTable.rows = this.mapChildData(list, columns, childData)
    } else {
      this.drilldownTable.columns = columns
      this.drilldownTable.rows = childData
    }
    this.childTableId = `${this.childStaticId}-${this.getTimestamp()}`;
  }

  mapChildData(list: any, columns: any, childData: any) {
    return _.map(list, (object: any) => {
      if (object.field_id == this.selectedHerarchy.field_id && object.name == this.selectedHerarchy.name) {
        object.child = {
          isChildTable: true,
          columns: columns,
          rows: childData
        }
      } else if (_.hasIn(object, 'child.rows') && !_.isEmpty(object.child.rows)) {
        const rows = _.get(object, 'child.rows', [])
        object.child.rows = this.mapChildData(rows, columns, childData)
      }
      return object;
    })
  }

  processChildData(response: any, field_id?:any) {
    const closedStatus: any = this.actionService.getClosedStatus()
    let summary: any = _.get(response, 'data.tat', {});
    let retingSummary: any = _.get(response, 'data.RatingsSummary', {});
    let hierarchyMap = _.get(response, 'data.hierarchyMap', {});
    let list: any = [];
    this.childDataCount = 0;
    if (!_.isEmpty(retingSummary)) {
      list = _.map(retingSummary, (object: any, key: string) => {
        const statusDistribution: any = _.get(retingSummary, key + ".status_distribution", {})
        object.name = hierarchyMap[key] || key;
        object.key = this.filterObj.nextFilter.field_id + '_' + object.name;
        object.field_id = this.filterObj.nextFilter.field_id; 
        object.level_name = this.filterObj.nextFilter.name;
        object.field_type = this.filterObj.nextFilter.type || this.filterObj.nextFilter.field_type;
        object.within_tat = 0;
        object.outside_tat = 0
        if (!_.isEmpty(summary) && summary[key]) {
          object.doc_count = summary[key].within_tat + summary[key].outside_tat;
          object.within_tat = summary[key].within_tat
          object.outside_tat = summary[key].outside_tat
          object.tat = summary[key].tat
        } else {
          object.doc_count = object.within_tat + object.outside_tat;
          object.within_tat = object.within_tat
          object.outside_tat = object.outside_tat
          object.tat = object.tat
        }
        object.tat = Math.round(object.tat);
        object.resolved = 0
        object.unresolved = 0
        object.isChildExists = !this.actionService.isEndOfHierarchy(this.filterObj.nextFilter.field_id);
        if ((object.isChildExists == true && object.field_type == 'hierarchy') || (this.filterObj.nextFilter?.child && this.filterObj.nextFilter.child.field_id)) {
          object.drillDown = []
        }
        // object.filters = this.actionService.clone(this.filterObj.appliedfilters);
        object.filters = JSON.parse(JSON.stringify(this.filterObj?.appliedfilters));
        object.percent = {
          doc_count: this.getPercentage(object.doc_count, object.doc_count),
          within_tat: this.getPercentage(object.within_tat, object.doc_count),
          outside_tat: this.getPercentage(object.outside_tat, object.doc_count)
        }
        object.within_tat_with_percentage = object.within_tat + '(' + object.percent.within_tat + '%)'
        object.outside_tat_with_percentage = object.outside_tat + '(' + object.percent.outside_tat + '%)'
        object = this.processDrilldownData(object)
        if (!_.isEmpty(field_id)) {
          object.field_id = field_id
          object.key = field_id + '_' + object.name;
          object.level_name = Helpers.hierarchyMapping[field_id]
          object.field_name = Helpers.hierarchyMapping[field_id]
          object.isChildExists = !this.actionService.isEndOfHierarchy(field_id);
          if ((object.isChildExists == true && object.field_type == 'hierarchy') || (this.filterObj.nextFilter?.child && this.filterObj.nextFilter.child.field_id)) {
            object.drillDown = []
          }
        }
        _.each(statusDistribution, (count: number, uuid: string) => {
          if (_.includes(closedStatus, uuid)) {
            object.resolved = object.resolved + count
          } else {
            object.unresolved = object.unresolved + count
          }
        })
        this.childDataCount += 1;
        return object;
      })
    }
    // this.initializeOverall();
    if (this.childDataCount > 100) {
      list.splice(100, this.childDataCount);      
    }
    return list;
  }

  getPercentage(count: number, total: number) {
    let percentage: any = '';
    percentage = (((count / total) * 100)).toFixed(1);
    if (percentage >= 0) {
      return percentage;
    } else {
      return '0.0'
    }
  }

  processDrilldownData(data: any) {
    if (this.filterObj && this.filterObj.nextFilter && this.filterObj.nextFilter.field_id) {
      data.field_id = this.filterObj.nextFilter.field_id;
      data.field_name = this.filterObj.nextFilter.name;
      data.field_type = this.filterObj.nextFilter.type || this.filterObj.nextFilter.field_type;
      data.field_sub_type = this.filterObj.nextFilter.field_sub_type;
      data.field_data_type = this.filterObj.nextFilter.data_type;
      data.field_possible_values = this.filterObj.nextFilter.possible_values;
      data.field_child = this.filterObj.nextFilter.child;
    } else if (this.filterObj && this.filterObj.currentFilter && this.filterObj.currentFilter.field_id) {
      data.field_id = this.filterObj.currentFilter.field_id;
      data.field_name = this.filterObj.currentFilter.field_name;
      data.field_type = this.filterObj.currentFilter.field_type || this.filterObj.currentFilter.type;
      data.field_sub_type = this.filterObj.currentFilter.field_sub_type;
      data.field_data_type = this.filterObj.currentFilter.field_data_type || this.filterObj.currentFilter.data_type;
      data.field_possible_values = this.filterObj.currentFilter.field_possible_values || this.filterObj.currentFilter.possible_values;
      data.field_child = this.filterObj.currentFilter.field_child || this.filterObj.currentFilter.child;
    } else if (this.selectedCustomFilter) {
      if (this.selectedCustomFilter.field_type && this.selectedCustomFilter.field_type == 'response') {
        data.field_type = this.selectedCustomFilter.field_type;
        data.field_sub_type = this.selectedCustomFilter.type;
      } else {
        data.field_type = this.selectedCustomFilter.type;
      }
      data.field_id = this.selectedCustomFilter.field_id;
      data.field_name = this.selectedCustomFilter.name;
      data.field_data_type = this.selectedCustomFilter.data_type;
      data.field_possible_values = this.selectedCustomFilter.possible_values;
      data.field_child = this.selectedCustomFilter.child;
    }
    return data
  }

  prepareDownloadQuery(query: any) {
    if (query && !_.isEmpty(query)) {
      let downloadQuery: any = {};
      downloadQuery.brand_id = this.brandId;
      downloadQuery.field_id = this.selectedCustomFilter.field_id;
      downloadQuery.field_type = this.selectedCustomFilter.field_type;
      downloadQuery.api_url = this._utilsService.apiUrlGeneration(environment.actionV1, environment.actionV1.actionStatsComparisonData);
      downloadQuery.question_id = 'primary_rating';
      downloadQuery.parameters = [];
      // downloadQuery.search_possible_values = false;
      downloadQuery.job_name = "action_dashboard_reporting"
      downloadQuery.job_type = 9
      downloadQuery.file_name = 'Action Summary - Closed Actionables - ' + this.selectedCustomFilter.name;
      var tabName = "tat"
      downloadQuery.report_name = 'Action Summary - Closed Actionables - ' + this.selectedCustomFilter.name;
      if (_.hasIn(this.filterObj, 'nextFilter.field_id')) {
        downloadQuery.field_id = this.selectedCustomFilter.field_id;
        downloadQuery.field_type = this.selectedCustomFilter.field_type;
      }
      // var universalFilter = Helpers.getUniversalFilter();
      // downloadQuery.parameters.push(Helpers.deepClone(_this.compLeaderboardExportDataQuery.query));
      const index = _.findIndex(this.apiParameters, { "field_id": query.field_id });
      if (index < 0) {
        this.apiParameters.push(query)
      } else {
        this.apiParameters[index] = query
      }
      downloadQuery.parameters = this.apiParameters;
      downloadQuery.search_possible_values = true;
      return downloadQuery
    }
    return {}
  }

  getExportColumns(display_name?: string) {
    let columns: any = [];
    var name = {
      header: display_name || 'Name',
      dataKey: "name",
      uniqueId: 'name',
      width:'140px',
      isSorting: true,
      isDrilldown: true,
      isClickable: true,
      defaultValue: "",
      showPercentage: false,
      order: "1"
    };

    var totalResponse = {
      header: "Issues",
      dataKey: 'actionables',
      uniqueId: 'actionables',
      width:'120px',
      style: {
        row: "flex-end",
        header: "flex-end"
      },
      isSorting: true,
      defaultValue: 0,
      showPercentage: false,
      order: "2"
    }

    var open = {
      header: "Unsolved",
      dataKey: 'unresolved',
      uniqueId: 'unresolved',
      width:'120px',
      isSorting: true,
      defaultValue: 0,
      showPercentage: false,
      order: "3"
    }
    var closed = {
      header: "Solved",
      dataKey: 'resolved',
      uniqueId: 'resolved',
      width:'120px',
      style: {
        row: "flex-end",
        header: "flex-end"
      },
      isSorting: true,
      showPercentage: false,
      defaultValue: 0,
      order: "4"
    }
    var distColumn = {
      dataKey: "tat_distribution",
      header: "Issue Distribution",
      uniqueId: 'tat_distribution',
      width:'120px',
      isSorting: true,
      defaultValue: 0,
      showPercentage: false,
      order: "5"
    };

    var averageTAT = {
      header: "Average TAT(hrs)",
      dataKey: 'tat',
      uniqueId: 'tat',
      width:'140px',
      style: {
        row: "flex-end",
        header: "flex-end"
      },
      isSorting: true,
      defaultValue: 0,
      showPercentage: false,
      order: "6"
    }
    var withinTAT = {
      header: "Within TAT",
      dataKey: 'within_tat_with_percentage',
      uniqueId: 'within_tat_with_percentage',
      width:'120px',
      style: {
        row: "flex-end",
        header: "flex-end"
      },
      isSorting: true,
      defaultValue: 0,
      showPercentage: this.showPercentage,
      order: "7"
    }
    var missedTAT = {
      header: "Missed TAT",
      dataKey: 'outside_tat_with_percentage',
      uniqueId: 'outside_tat_with_percentage',
      width:'120px',
      style: {
        row: "flex-end",
        header: "flex-end"
      },
      isSorting: true,
      defaultValue: 0,
      showPercentage: this.showPercentage,
      order: "8"
    }
    columns = [name, totalResponse, closed, averageTAT, withinTAT, missedTAT]
    return columns
  }

  getExportColumnsForReport(display_name?: string) {
    let columns: any = [];
    var name = {
      header: display_name || 'Name',
      dataKey: "name",
      uniqueId: 'name',
      width:'140px',
      isSorting: true,
      isDrilldown: true,
      isClickable: true,
      defaultValue: "",
      showPercentage: false,
      order: "1"
    };

    var totalResponse = {
      header: "Issues",
      dataKey: 'actionables',
      uniqueId: 'actionables',
      width:'120px',
      isSorting: true,
      defaultValue: 0,
      showPercentage: false,
      order: "2"
    }

    var closed = {
      header: "Solved",
      dataKey: 'resolved',
      uniqueId: 'resolved',
      width:'120px',
      isSorting: true,
      showPercentage: false,
      defaultValue: 0,
      order: "3"
    }

    var averageTAT = {
      header: "Average TAT(hrs)",
      dataKey: 'tat',
      uniqueId: 'tat',
      width:'140px',
      isSorting: true,
      defaultValue: 0,
      showPercentage: false,
      order: "4"
    }
    var withinTAT = {
      header: "Within TAT",
      dataKey: 'within_tat',
      uniqueId: 'within_tat',
      width:'120px',
      isSorting: true,
      defaultValue: 0,
      showPercentage: this.showPercentage,
      order: "5"
    }
    var missedTAT = {
      header: "Missed TAT",
      dataKey: 'outside_tat',
      uniqueId: 'outside_tat',
      width:'120px',
      isSorting: true,
      defaultValue: 0,
      showPercentage: this.showPercentage,
      order: "6"
    }
    var withinTATPercentage = {
      header: "Within TAT %",
      dataKey: 'percent.within_tat',
      uniqueId: 'percent.within_tat',
      width:'120px',
      isSorting: true,
      defaultValue: 0,
      showPercentage: this.showPercentage,
      order: "7"
    }
    var missedTATPercentage = {
      header: "Missed TAT %",
      dataKey: 'percent.outside_tat',
      uniqueId: 'percent.outside_tat',
      width:'120px',
      isSorting: true,
      defaultValue: 0,
      showPercentage: this.showPercentage,
      order: "8"
    }
    columns = [name, totalResponse, closed, averageTAT, withinTAT, missedTAT, withinTATPercentage, missedTATPercentage]
    return columns
  }

  onDownload() {
    if (this.childDataCount < 100) {
      let downloadConfig: any = {
        dataKey: 'uniqueId',
        headerKey: 'header',
        data: [{
          columns: this.downloadReportOverallHeader,
          rows: this.distributionTable.tableRow
        }, {
          columns: this.downloadReportDrilldownHeader,
          rows: this.comapreWithTable.tableRow
        }]
      }
      
      downloadConfig.fileDetails = {
        title: 'Action Summary - Closed_Actionables_By_'+ this.selectedCustomFilter.name,
        fileName: 'Action Summary - Closed_Actionables_By_'+ this.selectedCustomFilter.name,
        accountName: this.accountDetails.display_name || this.accountDetails.name,
        brandName: this.brandDetail.display_name || this.brandDetail.name
      }

      if (this.questionMapping.questions && this.questionMapping.questions.primary_rating) {
        downloadConfig.fileDetails.interaction = this.questionMapping.questions.primary_rating.text
      }

      if (downloadConfig.data.length) {
        this._analytics.prepareAndDownloadData(downloadConfig);
      }
    } else {
      this.actionService.createDownloadJob(this.downloadQueryParams);
    }
  }

  onFullscreenLeftBox(event, cardName): void {
    this.fullScreenLeftBox = event;
  }

  // Method to handle Escape key press
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.fullScreenLeftBox) {
      this.scoreWidgetComponent.onFullscreen(); // Call the onFullscreen method from ScoreWidgetComponent
    }
  }

  // Method to handle clicks outside the content
  handleClickOutside(event: MouseEvent) {
    const overlayElements = document.getElementsByClassName('fullscreen'); // Get all elements with the overlay class
    const contentElements = document.getElementsByClassName('action-hierarchy-summary'); // Get all elements with the content class

    // Check if the clicked element is the overlay
    const isOverlayClick = Array.from(overlayElements).some(overlay => overlay.contains(event.target as Node));
    const isContentClick = Array.from(contentElements).some(content => content.contains(event.target as Node));

    if (this.fullScreenLeftBox && isOverlayClick && !isContentClick) { // Only exit fullscreen if the overlay is clicked
      this.scoreWidgetComponent.onFullscreen(); // Call the onFullscreen method from ScoreWidgetComponent
    }
  }

  ngOnDestroy(): void {
    // Remove event listeners and reset
    document.removeEventListener('keydown', this.handleKeyDown.bind(this));
    document.removeEventListener('click', this.handleClickOutside.bind(this));
  }
}
